// extracted by mini-css-extract-plugin
module.exports = {"Pillbox":"Pillbox_Pillbox__3f4Xu","transparent":"Pillbox_transparent__3op9H","close":"Pillbox_close__xzFjJ"};